import { core, type Json } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';
import {
  type AuthLogin,
  type FabricLoginCallbackData,
  type FabricLoginOptions,
} from './types.js';

/**
 * 异步调用Native获取客户端缓存的用户授权信息
 * @example
 * true: 如果当前未登录: 则强制启动登陆面板执行完登陆流程, 返回调用端`授权`数据; 如果已登陆, 则直接返回`授权`不启动登陆面板.
 * false: 如果当前未登录/已经登陆都不启动登陆界面, 但是返回已存在的`授权`数据
 * @default false
 */
export const tryLogin: AuthLogin = <UserInfo extends Json = Json>() => {
  return new Promise<FabricLoginCallbackData<UserInfo>>((resolve, reject) => {
    core.call<
      'fabric_auth.login',
      FabricLoginOptions,
      FabricLoginCallbackData<UserInfo>
    >(
      'fabric_auth.login',
      {
        force: false,
      },
      (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          resolve(result.data);
        }
      }
    );
  });
};
